/**
 * Service to check system of application.
 *
 * Now it can check if app is running in cordova or in browser.
 */
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: 'root',
})
export class SystemService {
  /**
   * Check if application is running in cordova.
   */
  public isMobile(): boolean {
    return Capacitor.isNativePlatform();
  }

  /**
   * Check if application is running in web browser.
   */
  public isWeb(): boolean {
    return !this.isMobile();
  }

  public getOrCreateBrowserId(): string {
    const key = "browser_uuid";
    let uuid = localStorage.getItem(key);
    if (!uuid) {
      uuid = crypto.randomUUID();
      localStorage.setItem(key, uuid);
    }
    return uuid;
  }

  /**
   * Return device UUID.
   *
   * It returns:
   * - browser = browser userAgent
   * - HW device = device UUID
   *
   * !!! To work on HW devices it requires 'cordova-plugin-device' installed.
   */
  public async getDeviceUuid(): Promise<string> {
    if (this.isMobile()) {
      try {
        const deviceId = await Device.getId();
        return deviceId.identifier;
      } catch {
        // e.g. user denied tracking permission on iOS 17
      }
    }
    return `${navigator.userAgent}-${this.getOrCreateBrowserId()}`;
  }
}
